<template>
  <slot></slot>
</template>

<script setup lang="tsx" name="SmartProvide">
import { provide } from 'vue'

const props = defineProps(['lang', 'stylization', 'searchFormLayout', 'request', 'searchItemWidth', 'hasPower'])

provide('lang', (key: string) => {
  return (props.lang && props.lang(key)) || key
})
provide('hasPower', (key: string) => {
  return props.hasPower && props.hasPower(key)
})
provide('searchFormLayout', props.searchFormLayout || 'vertical')
provide('searchItemWidth', props.searchItemWidth || '300px')

provide('request', props.request)

provide('stylization', props.stylization || 'jms')
</script>
